// fly.service.ts
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
// import { Fly } from '../interfaces/fly'; // لو عندك انترفيس

@Injectable({ providedIn: 'root' })
export class FlyService {
  private base = `${environment.Server_URL}/flies`;

  constructor(private http: HttpClient) {}

  // GET /flies?per_page=&page=
  getAll(perPage: number, page: number): Observable<any> {
    return this.http.get<any>(`${this.base}?per_page=${perPage}&page=${page}`);
  }

  // GET /flies/{id}
  getById(id: number): Observable<any> { // غيّر any => Fly لو متاح
    return this.http.get<any>(`${this.base}/${id}`);
  }

  // POST /flies
  create(payload: FormData | any): Observable<any> {
    return this.http.post<any>(this.base, payload);
  }

update(id: number, payload: FormData | any): Observable<any> {
  if (payload instanceof FormData) {
    payload.append('_method', 'PUT');  // ✨ Laravel هيشوفه PUT
    return this.http.post(`${this.base}/${id}`, payload);
  }

  return this.http.put(`${this.base}/${id}`, payload, {
    headers: { 'Content-Type': 'application/json' }
  });
}

  // DELETE /flies/{id}
  delete(id: number): Observable<any> {
    return this.http.delete<any>(`${this.base}/${id}`);
  }

  // GET /flies/search?q=&page=
  search(q: string, page = 1, perPage = 10): Observable<any> {
    let params = new HttpParams()
      .set('q', q)
      .set('page', page)
      .set('per_page', perPage);
    return this.http.get<any>(`${this.base}/search`, { params });
  }
}
